import React, { useEffect, useRef, useState } from "react";
import { ComboBox, Item } from "@adobe/react-spectrum";
import { useAsyncList } from "@react-stately/data";
import { useTranslation } from "react-i18next";

// Define TypeScript types
interface Company {
    ic: string;
    nazev: string;
    ulice: string;
    mesto: string;
    psc: string;
    stat: string;
    platceDph: boolean;
    dic: string;
}

interface ICompanyNameDropDownProps{
    onChange:(data:Company)=> void;
    onBlur:()=>void;
    validationErrors: any
    textValue:string
}

const CompanyNameDropDown:React.FC<ICompanyNameDropDownProps> = ({onChange,onBlur,validationErrors,textValue})=> {
    const [selectedKey, setSelectedKey] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState("");
    const firstInputRef = useRef<any>(null);
    const { t } = useTranslation('contacts');
    const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
    useEffect(()=>{
      setInputValue(textValue);
      if (firstInputRef.current) {
        firstInputRef.current.focus();
      }
    },[textValue])
    const handleSelectionChange = (key: any) => {
      setSelectedKey(key);
      if (key) {
        const selectedCompany = list.items.find((x) => x.ic === key);
        if (selectedCompany) {
          setInputValue(selectedCompany.nazev);
          onChange(selectedCompany);
        }
      }
    };
  
    const handleInputChange = (value: string) => {
      setInputValue(value);
      setSelectedKey(null);
      list.setFilterText(value);
    };
  
    const handleOnBlur = () => {
      if (!selectedKey) {
        const updatedValue:Company = {
          ic:'',
          nazev : inputValue,
          ulice: '',
          mesto: '',
          psc: '',
          stat: '',
          platceDph: false,
          dic: ''
        }
        onChange(updatedValue);
        onBlur();
      }
    };

  let list = useAsyncList<Company>({
    async load({ filterText }) {
      if (!filterText || filterText.length < 3) return { items: [] };

      const response = await fetch(
        `https://atollon.flexibee.eu/remote/suggest/?country=cz&format=json&orgType=all&q=${filterText}`
      );
      const data = await response.json();
      const adresar = data?.winstrom?.adresar || [];
      return {
        items: adresar.map((item: any) => ({
          ic: item.ic.toString(),
          nazev: item.nazev,
          ulice:item.ulice,
          mesto:item.mesto,
          psc:item.psc,
          stat:item.stat,
          platceDph:item.platceDph,
          dic:item.dic
        })),
      };
    },
  });

  return (
    <ComboBox
        ref={firstInputRef}
        label={_t("company_name")}
        items={list.items}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        loadingState={list.loadingState}
        onLoadMore={list.loadMore}
        onSelectionChange={handleSelectionChange}
        validationState={validationErrors.name1 ? textValue === '' ? 'invalid' : 'valid':undefined}
        errorMessage={validationErrors.name1}
        width="100%"
        selectedKey={selectedKey}
        isRequired
        onBlur={handleOnBlur}
        allowsCustomValue
        >
      {(item) => <Item key={item.ic}>{item.nazev}</Item>}
    </ComboBox>
  );
}

export default CompanyNameDropDown